import { render } from "./ExportResultsModal.vue?vue&type=template&id=edf28880&scoped=true"
import script from "./ExportResultsModal.vue?vue&type=script&lang=js"
export * from "./ExportResultsModal.vue?vue&type=script&lang=js"

import "./ExportResultsModal.vue?vue&type=style&index=0&id=edf28880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edf28880"]])

export default __exports__